module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-17-640f8168478591c77ce5cd289689f7b9.jpg";